module.exports = __webpack_public_path__ + "img/photo-team1.e96c9cf5.png";